<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<!--input类型示例-->
		<FormItem prop="EquipmentNo">
			<Input style="width: 260px;" type="text" v-model="formInline.EquipmentNo" placeholder="设备编号">
			<span slot="prepend">设备编号</span>
			</Input>
		</FormItem>
		<FormItem label="充电站:" :label-width="100" prop="StationId">
			<Select filterable placeholder="站点列表" style="width: 200px;" v-model="formInline.StationId">
				<Option :value=0>全部</Option>
				<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
			</Select>
		</FormItem>
		<FormItem :label-width="70" label="设备类型:" prop="EquipmentType">
			<Select placeholder="输入设备类型" style="width:200px;" v-model="formInline.EquipmentType">
				<Option :value='1'>直流设备</Option>
				<Option :value='2'>交流设备</Option>
				<Option :value='3'>交直流一体设备</Option>
				<Option :value='4'>无线设备</Option>
				<Option :value='5'>其他</Option>
			</Select>
		</FormItem>
		<FormItem prop="EquipmentModel">
			<Input type="text" v-model="formInline.EquipmentModel" placeholder="设备型号">
			<span slot="prepend">设备型号</span>
			</Input>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmitList')">查询</Button>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('Upgrade')">升级</Button>
		</FormItem>
	</Form>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					StationId: 0,
					EquipmentNo: '',
					EquipmentModel: '',
					EquipmentTypeDesc: '',
				},
				PriceList: [{
					Id: 0,
					Name: 'name'
				}]
			};
		},
		computed: {
			...mapState({
				StationList: 'Stations',
				EquipmentModelDefine: 'EquipmentModelDefine'
			})
		},
		methods: {},
	}
</script>

<style>
</style>
